import * as React from 'react';
import { INewBuildingApartment } from '../../types/newBuldings/apartments';
import { ApartmentsList } from './ApartmentsList';
import * as styles from './ApartmentsListGroup.css';

interface IApartmentsListGroupProps {
  groups: INewBuildingApartment[][];
}

export function ApartmentsListGroup({ groups }: IApartmentsListGroupProps) {
  return (
    <div className={styles['group']}>
      {groups.map((item, index) => (
        <div key={index} className={styles['group__item']}>
          <ApartmentsList key={index} apartments={item} />
        </div>
      ))}
    </div>
  );
}
